/**
 * Cursor module
 * 
 * @description
 * <p>Sets up custom cursor for site</p>
 * <p>On page load, adds cursor div, hides it at launch and adds handlers for mouse events so it can show/hide and shrink/grow as appropriate.</p>
 * <p>Self-initializes when page loads.</p>
 * 
 * @module cursor
 * 
 * @example 
 * {@lang JavaScript}
 * site.cursor.registerScrollRegion($('.bioModal .bio'))
 * site.cursor.registerNativeContainer($('.vid-content'));
 * site.cursor.$cursor.removeClass('hide');
 * 
 * @namespace site.cursor
 */
( /* @lends module:cursor */ function(site,$){
	"use strict";
(function($){
	var $cursor = $('<div class="cursor"></div>'),
		hoverable = 'button, a, .hoverable, .scroll-indicator-svg, input, [role="option"], select, option, textarea',
		lastPos = {x:0,y:0}; // last cursor position recorded

	// /**
	 // * Cursor Initializer
	 // */
	// function init() {
		// $cursor.appendTo('body');
		// cursorHide();

		// listeners();
	// }

	// /**
	 // * All Global listeners get registered here
	 // */
	// function listeners() {
		// // Site/Global Events
		// $(window).on('scroll', function() {
			// cursorHide();
		// });

		// // document based events
		// $(document)
			// .on('mousemove', function(e) {
				// handleMouseMove(e);
				// cursorPos();
				// cursorShow();
			// })
			// .on('mouseleave', function() {
				// cursorHide();
			// })
			// .on('mouseenter', function() {
				// cursorShow();
			// })
			// .on('mouseenter', hoverable, function() {
				// cursorGrow();
			// })
			// .on('mouseleave', hoverable, function() {
				// cursorShrink();
			// });
	// }

	// /**
	 // * Cursor Grow animation/logic
	 // */
	// function cursorGrow(){
		// $cursor.addClass('active');
	// }

	// /**
	 // * Cursor Shrink animation/logic
	 // */
	// function cursorShrink(){
		// $cursor.removeClass('active');
	// }

	// /**
	 // * Cursor Show animation/logic
	 // */
	// function cursorShow() {
		// $cursor.show();
	// }

	// /**
	 // * Cursor Hide animation/logic
	 // */
	// function cursorHide() {
		// $cursor.hide();
	// }

	// /**
	 // * Set Cursor Position relative to document to match user's mouse position
	 // */
	// function cursorPos() {
		// cursorShow();
		// $cursor.css({
			// 'left':lastPos.x + 'px',
			// 'top':lastPos.y + 'px',
			// 'transform':'translate(-50%, -50%)' // center on mouse cursor
		// });

	// }

	// function handleMouseMove(event) {
		// var eventDoc, doc, body;

		// event = event || window.event; // IE-ism

		// // If pageX/Y aren't available and clientX/Y are, calculate pageX/Y.
		// // (This is to support old IE)
		// if (event.pageX == null && event.clientX != null) {
			// eventDoc = (event.target && event.target.ownerDocument) || document;
			// doc = eventDoc.documentElement;
			// body = eventDoc.body;

			// event.pageX = event.clientX +
				// (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
				// (doc && doc.clientLeft || body && body.clientLeft || 0);
			// event.pageY = event.clientY +
				// (doc && doc.scrollTop  || body && body.scrollTop  || 0) -
				// (doc && doc.clientTop  || body && body.clientTop  || 0 );
		// }

		// lastPos.x = event.pageX;
		// lastPos.y = event.pageY;
	// }

	// /**
	 // * @function site.cursor.registerScrollRegion
	 // * @description Registers a region for scrolling so cursor can be hidden on scroll
	 // * @param {string} region - A DOM element or selector
	 // * @example
	 // * {@lang javascript}
	 // * site.cursor.registerScrollRegion($('.bioModal .bio'));;
	 // * @public
	 // */
	// function registerScrollRegion(region){
		// $(region).on('scroll', function() {
			// cursorHide();
		// });
	// }

	// /**
	 // * @function site.cursor.registerNativeContainer
	 // * @description Registers container to hide/show cursor on mouseenter/mouseleave
	 // * @param {string} container - A DOM element or selector
	 // * @example
	 // * {@lang javascript}
	 // * site.cursor.registerNativeContainer($('.vid-content'));;
	 // * @public
	 // */
	// function registerNativeContainer($container) {
		// $container
			// .on('mouseenter', function() {
				// $cursor.addClass('hide');
			// })
			// .on('mouseleave', function() {
				// $cursor.removeClass('hide');
			// });
	// }

	// site.cursor = {
		// registerScrollRegion: registerScrollRegion,
		// registerNativeContainer: registerNativeContainer,
		// $cursor: $cursor
	// }

	// $(function(){
		// init();
		// $( document ).ajaxComplete(function(event, xhr, options) {
          // if (options.url.toLowerCase().indexOf("api/newsroom/node") >= 0 || options.url.toLowerCase().indexOf("api/newsroom/list") >= 0) {
                // init();
            // }
        // });
	// });
    })(jQuery);
})(window.site=window.site || {}, jQuery);
